import { endlessRequest } from "./core";
import { EndlessRequest, EndlessResponse } from "./types";

export type PostRequestOptions = Omit<EndlessRequest, "method">;

/**
 * Main function to do a Post request
 *
 * @param options PostRequestOptions
 * @returns
 */
export async function post<Req, Res>(options: PostRequestOptions): Promise<EndlessResponse<Req, Res>> {
  const response: EndlessResponse<Req, Res> = await endlessRequest<Req, Res>({ ...options, method: "POST" });
  return response;
}
